export const MuiTableCell = {
  root: {
    fontSize: '1rem',
  },
  head: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
};
